import { render, staticRenderFns } from "./GlobalPartnersStateDetailView.vue?vue&type=template&id=7fa2abe5&scoped=true"
import script from "./GlobalPartnersStateDetailView.vue?vue&type=script&lang=js"
export * from "./GlobalPartnersStateDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa2abe5",
  null
  
)

export default component.exports